import styled from 'styled-components'
import { fonts } from 'shared/lib'

const ModalPanelTitle = styled.h3`
  ${fonts.SUBTITLE_2};
  margin: 0;
`

export default ModalPanelTitle
